module.exports = __webpack_public_path__ + "static/img/far5_active.f9fa76af.jpg";